import { UnsupportedLanguages } from 'types/enums';

export const getIsUnsupportedLocale = (
    locale: UnsupportedLanguages | string | undefined,
): locale is UnsupportedLanguages => {
    return (
        !!locale && Object.values<string>(UnsupportedLanguages).includes(locale)
    );
};
